import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const SettingsManageFinancialAccountViewChunk = React.lazy(() =>
  import('../containers/SettingsManageFinancialAccountView').then(
    ({ SettingsManageFinancialAccountView }) => ({
      default: SettingsManageFinancialAccountView,
    })
  )
)

export const SettingsManageFinancialAccountPage = () => {
  const intl = useProcurifyIntl()

  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.manageFinancialAccountPageTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsPageTitle),
        },
        {
          name: intl.formatMessage(messages.manageFinancialAccountPageTitle),
        },
      ]}
    >
      <SettingsManageFinancialAccountViewChunk />
    </Page>
  )
}
